/**
 * /about: M5.T6.
 *
 * Per IMPLEMENTATION_PLAN.md §7 M5.T6: ~200 words, brand voice
 * playful-confident. The home-page footer links here.
 *
 * The page is a flat document that answers "what is this and who made it"
 * without selling anything. Item 1 added the one interactive affordance: the
 * Free Draw CTA moved here off the landing, so the page now takes `connState`
 * to gate that button on the WS session. Everything else is static, no shared
 * state, no third-party fetches.
 */

import type { ConnState } from "../ws.js";
import { FreeDrawButton } from "../components/FreeDrawButton.js";

type AboutProps = {
  /** WS connection state: gates the Free Draw CTA. Optional so the page still
   *  renders (button disabled) outside a live connection. */
  connState?: ConnState;
};

export function About({ connState }: AboutProps = {}) {
  return (
    <main class="about-page" data-testid="about-page" role="main" aria-labelledby="about-heading">
      <h1 id="about-heading" class="about-heading">
        About drawlol
      </h1>

      <p>
        drawlol is a drawing game. You draw stuff. Your friends guess what it is. There's a timer.
        There are points. Whoever has the most points wins. That's it.
      </p>

      <h2>What it isn't</h2>

      <p>
        It isn't an account. You won't make one. You won't forget the password to one. You won't get
        an email about one.
      </p>

      <p>
        It isn't an ad platform. You won't see ads. We're not selling your attention to anyone,
        because we're not collecting it.
      </p>

      <p>It isn't deep. The whole game fits in a few minutes. That's the point.</p>

      <h2>How it works</h2>

      <p>
        Open a room. Share the URL with a friend (or three). One person draws, everyone else
        guesses. The faster you guess, the more points you get. Take turns drawing. Eventually
        someone wins. Then you play again.
      </p>

      <h2>Just want to draw?</h2>

      <p>
        No room, no guessing, no timer — just a blank canvas you can share with a friend. Start a
        Free Draw session and doodle.
      </p>

      <div class="about-freedraw" data-testid="about-freedraw">
        <FreeDrawButton connState={connState ?? { kind: "connecting" }} />
      </div>

      <h2>Who made this</h2>

      <p>
        Yi made this. They like drawing games. They didn't love that most of them are stuffed with
        ads or want a phone number, so they built one that asks for neither.
      </p>

      <p>
        Inspired by skribbl.io, Drawful, and Gartic Phone — gratefully. Default word lists are
        reviewed in pull requests, so the additions are public.
      </p>

      <p class="about-back">
        <a href="/" data-testid="about-back-link">
          ← back to drawlol
        </a>
      </p>
    </main>
  );
}
